import Utils from '@/core/utils'
const state = {
  // 已选中的数据
  selectedData: [],
  // 已载入（已添加）的构件
  loadedData: [],
  categories: [],
}
const getters = {
  selectedData: (state) => state.selectedData,
  categoryTree: (state) => {
    return Utils.listToTree(state.categories, 'id', null)
  },
  platCategories: (state) => state.categories,
  rootCategory: (state) => {
    return state.categories.find((c) => !c.parentId) || {}
  },
  getCategoryById: (state) => (id, nodeKey = 'id') => {
    return state.categories.find((c) => c[nodeKey] === id) || {}
  }
}
const mutations = {
  setSelectedData(state, data) {
    state.selectedData = data
  },
  setLoadedData(state, data) {
    state.loadedData = data
  },
  setCategories(state, data) {
    data.forEach((d) => {
      if (d.code) {
        d.id = d.code - 0
        d.parentId = d.parentCode ? d.parentCode - 0 : null
      }
      d.filteredCount = d.count
    })
    state.categories = Utils.uniqueTreeList(data)
  },
  updateCategories(state, categories) {
    const map = new Map()
    categories.forEach((c) => {
      if (c.code) {
        c.id = c.code - 0
        c.parentId = c.parentCode ? c.parentCode - 0 : null
      }
      map.set(c.id, c)
    })
    state.categories.forEach((category) => {
      const c = map.get(category.id)
      category.filteredCount = c ? c.count : 0
    })
  }
}
const actions = {
  async loadCategories({ commit }, params) {
    try {
      const res = await this.$api.components.categroies(params)
      commit('setCategories', res || [])
    } catch (error) {
      commit('setCategories', [])
    }
  },
  async refreshCategories({ commit }, params) {
    try {
      const query = Utils.removeKeys(params, ['gjwCategoryId', 'gjwCategoryCode', 'spaceCategoryId'])
      const res = await this.$api.components.categroies(query)
      commit('updateCategories', res || [])
    } catch (error) {
      commit('updateCategories', [])
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
